import GeneralTemplateDark from './GeneralTemplateDark';

export default GeneralTemplateDark;
